/**
 * @generated SignedSource<<5b19641279847f68b1df9bb5c4fd019b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EventScreenNewMobile_query$data = {
  readonly " $fragmentSpreads": FragmentRefs<"EventHostInvitationBanner_query" | "EventScreenAttendCard_query" | "EventScreenJoin_query" | "SponsorsSection_query">;
  readonly " $fragmentType": "EventScreenNewMobile_query";
};
export type EventScreenNewMobile_query$key = {
  readonly " $data"?: EventScreenNewMobile_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"EventScreenNewMobile_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventScreenNewMobile_query",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SponsorsSection_query"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EventScreenAttendCard_query"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EventScreenJoin_query"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EventHostInvitationBanner_query"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "766b6c1bab0eb1e2b69f66f2605bdf06";

export default node;
